module.exports = __webpack_public_path__ + "res/img_usage_type_school.f2e7b8984331ec6a1d82439065d89ad3.png";